/**
 * Created by m.igrachev on 3/2/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/CheckboxItemDocumentedProps";
import Validatable from "../validatable/Validatable";

export default class CheckboxItem extends Validatable {
    constructor(props) {
        super(props);

        this.onKeyDown = this.onKeyDown.bind(this);
    }

    render() {
        //TODO: implement indeterminate if we want to reuse the same Item for CheckboxTree when we are to implement it :).
        let extraClasses = this.props.extraClasses || "";
        let containerClass = extraClasses + " tq-checkbox-option";
        containerClass += this.props.active ? " tq-selected" : "";
        containerClass += this.props.disabled ? " tq-disabled" : "";
        containerClass += this.props.marked ? " tq-tab-selection" : "";
        let label = this.props.label ? this.props.label : this.props.value;
        let onClick, tabIndex;
        if (!this.props.disabled) {
            onClick = this.props.onClick.bind(this, this.props.value);
            tabIndex = "0";
        }

        let displayComponentInvalid = false;
        if (typeof this.props.valid === "boolean") {
            displayComponentInvalid = !this.props.valid;
        }

        containerClass += displayComponentInvalid ? " tq-has-error" : "";

        return (
            <div
                className={containerClass}
                tabIndex={tabIndex}
                onKeyDown={this.onKeyDown}
                data-tq-id={this.props.dataTqId}
            >
                <div className="tq-checkbox" onClick={onClick}>
                    <input
                        className="tq-checkbox"
                        type="checkbox"
                        disabled={this.props.disabled}
                        value={this.props.value}
                        tabIndex="-1"
                    />
                </div>
                <span className="tq-text-node" onClick={onClick}>
                    {label}
                </span>
                {this.props.required && <i className="tq-required" />}
            </div>
        );
    }

    onKeyDown(event) {
        if (event.key === "Enter") {
            this.props.onClick(this.props.value);
        }
    }
}

CheckboxItem.displayName = "CheckboxItem";

CheckboxItem.propTypes = Object.assign({}, Validatable.propTypes, {
    extraClasses: PropTypes.string,
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    marked: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    indeterminate: PropTypes.bool,
    dataTqId: PropTypes.string
});

CheckboxItem.documentedProps = documentedProps;
